const inventoryUpdateSnack = require('./inventoryUpdate-snack')
const inventoryUpdateQuickview = require('./inventoryUpdate-quickview')
const fullcontForm          = require('../../../../../components/fullcont/fullcont-form')
const scrim                 = require('../../../../../components/scrim/scrim')
const textfieldHandler      = require('../../../../../components/textfield/textfield-handler')

var updating = false

export function setReadonlyTooltips(htmlFc){

      const readonlyInputs = htmlFc.fullcontHTML.querySelectorAll(
            '#inventoryUpdate_form_inventory_update .textfield-disabled input'
      )

      readonlyInputs.forEach((input)=>{
            const fieldColumn = input.closest('.textfield')?.parentElement

            if(fieldColumn === null || fieldColumn === undefined){ return }

            fieldColumn.setAttribute('title', input.value)
      })
}

export function setOriginalPlaceholders(htmlFc){

      htmlFc.entityMT[0].dataCopy.forEach((original)=>{
            const line = htmlFc.fullcontHTML.querySelector(`.line-${original.id}`)

            if(line === null){ return }

            line.querySelector('.qty input')?.setAttribute('placeholder', original.qty)
            line.querySelector('.selling_price input')?.setAttribute('placeholder', original.selling_price)
      })
}

export function validateQty(detail, htmlFc){

      const line = htmlFc.fullcontHTML.querySelector(`.line-${detail.lineId}`)

      if(line === null){ return }

      const qtyInput = line.querySelector('.qty input')
      const original = htmlFc.entityMT[0].dataCopy.find((row)=>`${row.id}` === `${detail.lineId}`)

      if(qtyInput === null || original === undefined){ return }

      validateQtyInput(qtyInput, original.qty)
}

export function validateSellingPrice(detail, htmlFc){

      const line = htmlFc.fullcontHTML.querySelector(`.line-${detail.lineId}`)

      if(line === null){ return }

      const sellingPriceInput = line.querySelector('.selling_price input')

      if(sellingPriceInput === null){ return }

      validateSellingPriceInput(sellingPriceInput)
}

export function getExceededQuantityLines(htmlFc){

      const exceededLines = []

      htmlFc.entityMT[0].dataCopy.forEach((original)=>{
            const line     = htmlFc.fullcontHTML.querySelector(`.line-${original.id}`)
            const qtyInput = line?.querySelector('.qty input')

            if(qtyInput === null || qtyInput === undefined){ return }

            const enteredQty   = Number(qtyInput.value)
            const availableQty = Number(original.qty)

            if(!Number.isFinite(enteredQty) || enteredQty <= availableQty){ return }

            textfieldHandler.error(qtyInput.closest('.textfield'))

            exceededLines.push({
                  purchase_code: original.purchase_code,
                  item:          original.item_description,
                  unit:          original.unit,
                  available_qty: availableQty,
                  entered_qty:   enteredQty,
            })
      })

      return exceededLines
}

export function validateUpdate(htmlFc){

      if(!fullcontForm.wasEdited(htmlFc)){
            showMessage('No inventory changes were found.')
            return false
      }

      const changedLines = getChangedLines(htmlFc.entityMT[0])

      if(changedLines.length === 0){
            showMessage('No inventory changes were found.')
            return false
      }

      const validation = validate(changedLines, htmlFc)

      if(validation !== ''){
            showMessage(validation)
            return false
      }

      return true
}

export async function update(htmlFc, callback){

      if(updating){ return }

      if(!fullcontForm.wasEdited(htmlFc)){
            showMessage('No inventory changes were found.')
            return
      }

      const changedLines = getChangedLines(htmlFc.entityMT[0])

      if(changedLines.length === 0){
            showMessage('No inventory changes were found.')
            return
      }

      const validation = validate(changedLines, htmlFc)

      if(validation !== ''){
            showMessage(validation)
            return
      }

      const formData = new FormData()
      formData.append('entity', 'item')
      formData.append('lines', JSON.stringify(changedLines))

      const controller = new AbortController()
      const timeout    = setTimeout(()=>{ controller.abort() }, 30000)

      updating = true
      scrim.showLoading()

      try{
            const response = await fetch('./server/php/sql/updateInventoryUpdate.php', {
                  method:      'POST',
                  body:        formData,
                  signal:      controller.signal,
                  credentials: 'same-origin',
            })

            if(!response.ok){ throw new Error(response.status) }

            const result = await response.json()

            if(result.authentication?.val !== 'ok'){
                  showMessage('Your session is no longer valid. Please sign in again.')
                  return
            }

            if(result.authorization?.val !== 'ok'){
                  showMessage('You are not authorized to update inventory.')
                  return
            }

            if(result.error?.val !== 'ok'){
                  if(result.error?.val === 'inventoryQuantityChanged'){
                        updateAvailableReference(result.extrainfo, htmlFc)
                        showQuantityExceededDialog(htmlFc)
                        return
                  }

                  showMessage(result.extrainfo?.message || getBackendMessage(result.error?.val))

                  if(result.error?.val === 'inventoryDataChanged' && callback !== undefined){
                        callback(result)
                  }

                  return
            }

            showMessage('Inventory updated successfully.')

            if(callback !== undefined){ callback(result) }

      }catch(error){
            showMessage('The inventory could not be updated. Please try again.')

      }finally{
            clearTimeout(timeout)
            scrim.hideLoading()
            updating = false
      }
}

export function getChangedLines(mt){

      const originalById = new Map()
      const changedLines  = []

      mt.dataCopy.forEach((line)=>{
            originalById.set(`${line.id}`, line)
      })

      mt.data.forEach((line)=>{
            const original = originalById.get(`${line.id}`)

            if(original === undefined){ return }

            const qtyChanged          = Number(line.qty) !== Number(original.qty)
            const sellingPriceChanged = Number(line.selling_price) !== Number(original.selling_price)

            if(!qtyChanged && !sellingPriceChanged){ return }

            changedLines.push({
                  id:             `${line.id}`,
                  qty:            line.qty,
                  selling_price:  line.selling_price,
                  available_qty:  original.qty,
                  original_selling_price: original.selling_price,
                  purchase_code:  original.purchase_code,
                  item:           original.item_description,
                  unit:           original.unit,
            })
      })

      return changedLines
}

function validate(lines, htmlFc){

      for(const line of lines){
            const availableQty  = Number(line.available_qty)
            const lineName      = `${line.purchase_code} - ${line.item}`
            const qtyInput      = htmlFc.fullcontHTML.querySelector(`.line-${line.id} .qty input`)
            const sellingPriceInput = htmlFc.fullcontHTML.querySelector(`.line-${line.id} .selling_price input`)

            if(qtyInput === null || !validateQtyInput(qtyInput, availableQty)){
                  return `Available Qty for ${lineName} must be between 0 and ${availableQty}.`
            }

            if(sellingPriceInput === null || !validateSellingPriceInput(sellingPriceInput)){
                  return `Selling Price for ${lineName} must be greater than 0.`
            }
      }

      return ''
}

function validateQtyInput(qtyInput, availableQty){

      const qty = Number(qtyInput.value)
      const invalid = qtyInput.value === '' ||
                      !Number.isFinite(qty) ||
                      !Number.isInteger(qty) ||
                      qty < 0 ||
                      qty > Number(availableQty)

      if(invalid){
            textfieldHandler.error(qtyInput.closest('.textfield'))
            return false
      }

      textfieldHandler.errorClean(qtyInput.closest('.textfield'))
      return true
}

function validateSellingPriceInput(sellingPriceInput){

      const sellingPrice = Number(sellingPriceInput.value)
      const invalid = sellingPriceInput.value === '' ||
                      !Number.isFinite(sellingPrice) ||
                      sellingPrice <= 0

      if(invalid){
            textfieldHandler.error(sellingPriceInput.closest('.textfield'))
            return false
      }

      textfieldHandler.errorClean(sellingPriceInput.closest('.textfield'))
      return true
}

function getBackendMessage(error){

      const messages = {
            invalidData:          'The submitted inventory data is invalid.',
            inventoryDataChanged: 'Inventory availability changed. The list will be reloaded.',
            inventoryQuantityChanged: 'Inventory availability changed. Review the highlighted quantity.',
            invalidQuantity:      'Available Qty must be between 0 and the current available quantity.',
            invalidSellingPrice:  'Selling Price must be greater than 0.',
      }

      return messages[error] || 'The inventory could not be updated.'
}

function updateAvailableReference(extraInfo, htmlFc){

      if(extraInfo?.id === undefined || extraInfo?.available_qty === undefined){ return }

      const original = htmlFc.entityMT[0].dataCopy.find((line)=>`${line.id}` === `${extraInfo.id}`)

      if(original === undefined){ return }

      original.qty = `${extraInfo.available_qty}`

      const qtyInput = htmlFc.fullcontHTML.querySelector(`.line-${extraInfo.id} .qty input`)
      qtyInput?.setAttribute('placeholder', original.qty)

      validateQty({
            lineId: `${extraInfo.id}`,
      }, htmlFc)
}

function showQuantityExceededDialog(htmlFc){

      const exceededLines = getExceededQuantityLines(htmlFc)

      if(exceededLines.length === 0){ return }

      inventoryUpdateQuickview.start({
            act:   'show',
            lines: exceededLines,
      })
}

function showMessage(text){

      inventoryUpdateSnack.start({
            act:  'show',
            id:   'message',
            text: text,
      })
}
